<template>
  <component
    :is="getActionLinkComponent(content.target)"
    v-if="!content.hideOnWeb"
    class="group w-full flex py-2"
    :class="{ 'cursor-pointer bg-transparent p-0 text-left': isActionLinkOnly(content.target) }"
    :rel="activeL2?.target?.url === content?.target?.url ? 'noopener nofollow' : undefined"
    v-bind="getActionLinkAttrs(content.target)"
    @click="clickL3(content)"
  >
    <span class="group-hover:-rotate-3" :style="{ 'transition-duration': `${SLANT_TRANSITION_DURATION}ms` }">
      <span class="underscore body-3">
        {{ content.title }}
      </span>
    </span>
  </component>
</template>

<script lang="ts" setup>
import type { MegaMenuL1Context } from '#content/contexts/megamenu'
import type { MenuItem } from '#types/components/cms/mega-menu'
import { MegaMenuL1ContextKey } from '#content/contexts/megamenu'

const { content } = defineProps<{ content: MenuItem }>()
const SLANT_TRANSITION_DURATION = 200
const { $gtm } = useNuxtApp()
const { getActionLinkAttrs, getActionLinkComponent, getActionLinkHandler, isActionLinkOnly } = useCmsActionLink('header:mega-menu')

const { activeL1, activeL2 } = inject(MegaMenuL1ContextKey, {} as MegaMenuL1Context)

const getClickEventLabel = (...args) => args
  .map((mi, index) => formatMegaMenuLevelLabel(getMegaMenuItemLabel(mi), (index + 1) as 1 | 2 | 3))
  .filter(Boolean)
  .join(' | ')

const clickL3 = (l3: MenuItem) => {
  if (isActionLinkOnly(l3.target)) getActionLinkHandler(l3.target, getMegaMenuItemLabel(l3))?.()
  $gtm.push('topNav.onClickTopNavLink', getClickEventLabel(activeL1?.value, activeL2?.value, l3))
}
</script>
